<vex-scrollbar *ngIf="didGetMembership" class="h-full relative pricing">
  <div @stagger>
    <div class="pt-8 pb-6 px-gutter">
      <!-- <h1 @fadeInUp class="display-2 mt-0 mb-2 heading text-center text-primary">{{'MEMBERSHIPS.PRICING_PLANS' | translate}}</h1> -->
      <!-- <h2 @fadeInUp class="subheading-4 subheading text-hint text-center max-w-lg mx-auto m-0">{{'MEMBERSHIPS.BEST_SOLUTION_BEST_PRICE' | translate}}</h2> -->
      <div class="mb-2">
        <a href="/">
          <div class="flex flex-row justify-center gap-6">
            <img alt="Logo" src="assets/img/logos/logo-full.png" class="h-8" />

            <div *ngIf="this.partner">
              <img src="assets/img/integrations/shield.png" class="h-8" alt="Shield" />
            </div>
          </div>
        </a>
      </div>

      <h2 @fadeInUp class="subheading-4 subheading text-primary text-center mx-auto m-0">
        {{ 'MEMBERSHIPS.BEST_SOLUTION_BEST_PRICE' | translate }}
      </h2>

      <div
        *ngIf="isLengthAvailable"
        class="mt-4 subscription-length"
        fxLayout="row"
        fxLayoutAlign="center center">
        <mat-button-toggle-group
          [formControl]="lengthCtrl"
          (change)="subscriptionLengthChanged($event.value)"
          matTooltip="{{ 'MEMBERSHIPS.PAY_YEARLY_AND_SAVE' | translate }}">
          <mat-button-toggle class="length-toggle" value="12">{{
            'YEARLY' | translate
          }}</mat-button-toggle>
          <mat-button-toggle class="length-toggle" value="1">{{
            'MONTHLY' | translate
          }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>

    <div
      class="px-gutter mb-6 subscription-tiers"
      fxLayout="row"
      fxLayout.xs="column"
      fxLayoutAlign="start stretch"
      fxLayoutAlign.xs="start stretch"
      fxLayoutGap="24px">
      <div
        *ngFor="let membership of $products; let $index = index"
        class="card pricing-tier"
        [class.free-tier]="$index == 0"
        [class.starter-tier]="$index == 1"
        [class.basic-tier]="$index == 2"
        [class.pro-tier]="$index == 3"
        [class.enterprise-tier]="membership.url"
        [class.package-selected]="$index === preferredPackageIndex$"
        (click)="onPackageSelected($index)"
        fxLayout="column"
        fxLayoutAlign="start center"
        fxFlex>
        
        <!-- Icon -->
        <div class="inline-block p-4 rounded-full text-primary mx-auto flex items-center justify-center bg-primary-light tier-icon">
          <ic-icon [icon]="getIcon($index)" size="36px"></ic-icon>
        </div>

        <!-- Tier Name -->
        <h2 class="headline my-4 highlighted" align="center">
          {{ membership.name | translate }}
        </h2>

        <!-- Price Labels between Name and Content -->
        <div fxLayout="column" fxLayoutAlign="start center" fxFlex>
          <div *ngIf="membership.price === 0" class="h-full" fxLayout="column" fxLayoutAlign="start center">
            <h3 class="display-2 font-bold">
              {{ 'MEMBERSHIPS.FREE' | translate | uppercase }}
            </h3>
            <span class="text-secondary">&nbsp;</span>
            <span *ngIf="lengthCtrl.value == '12'" class="text-center">&nbsp;</span>
          </div>

          <div
            *ngIf="membership.price !== 0 && !membership.url"
            class="mt-2 h-full"
            fxLayout="column"
            fxLayoutAlign="start center">
            <h3 class="display-2 font-bold highlighted">
              <span class="highlighted-secondary headline align-top">$</span>
              {{
                lengthCtrl.value == '12'
                  ? (membership.price / 12.0 | number : '1.0-0')
                  : membership.price
              }}
            </h3>
            <span class="text-secondary">{{ 'MEMBERSHIPS.PER_MONTH' | translate | uppercase }}</span>
            <span
              *ngIf="lengthCtrl.value == '12' && getBalanceSaving(membership) != null"
              class="text-center">
              Save
              {{ getBalanceSaving(membership).percentage | number : '1.0-0' }}% (${{
                getBalanceSaving(membership).balance | number : '1.0-0'
              }}/year)
            </span>
          </div>

          <!-- Contact Sales Button for Enterprise Membership -->
          <button
            *ngIf="membership.url"
            class="rounded-full max-w-full w-32 mt-4 mb-2 subscribe-button"
            color="primary"
            type="button"
            (click)="contactSales()"
            mat-raised-button>
            {{ 'MEMBERSHIPS.CONTACT_SALES' | translate }}
          </button>
        </div>

        <!-- Features List -->
        <section>
          <ul class="feature-list">
            <li *ngFor="let feature of membership.features">
              <div class="flex flex-row">
                <div class="checkmark-container">
                  <span aria-hidden="true" class="checkmark">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16">
                      <path
                        fill="currentColor"
                        d="m5.72 12.53-3.26-3.3c-.7-.72.36-1.77 1.06-1.06l2.73 2.77 6.35-6.35a.75.75 0 0 1 1.06 1.06l-6.88 6.88a.78.78 0 0 1-.5.23.83.83 0 0 1-.56-.23z"></path>
                    </svg>
                  </span>
                </div>
                <span class="pl-2">{{ feature }}</span>
              </div>
            </li>
          </ul>
        </section>

        <!-- Action Buttons for Other Tiers -->
        <div fxLayout="column" fxLayoutAlign="end center" fxFlex>
          <button
            *ngIf="$index === subscribedIndex$"
            class="rounded-full max-w-full w-32 mt-4 subscribe-button"
            color="primary"
            type="button"
            mat-raised-button>
            {{ 'MEMBERSHIPS.CURRENT' | translate }}
          </button>

          <button
            *ngIf="$index !== subscribedIndex$ && !membership.url"
            class="rounded-full max-w-full w-32 mt-4 subscribe-button"
            color="primary"
            type="button"
            (click)="onSubscribe($index)"
            mat-raised-button>
            {{ 'MEMBERSHIPS.GET_STARTED' | translate }}
          </button>
        </div>
      </div>
    </div>

<div
  *ngIf="!didGetMembership"
  class="h-full my-4"
  fxLayout="row"
  fxLayoutAlign="center center">
  <mat-spinner diameter="40"></mat-spinner>
</div>
